module.exports = __webpack_public_path__ + "media/C_Y.f0708165.mp3";